import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";

interface RejectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (reason: string) => void;
}

function PaperComponent(props: any) {
  const nodeRef = useRef(null);
  return (
    <Draggable handle='#rejection-dialog-title' cancel={'[class*="MuiDialogContent-root"]'} nodeRef={nodeRef}>
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

const RejectionDialog: React.FC<RejectionDialogProps> = ({ open, onClose, onSave }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (open) {
      setReason("");
      setError("");
    }
  }, [open]);

  const handleSave = () => {
    if (!reason.trim()) {
      setError("반려 사유를 입력해주세요.");
      return;
    }
    onSave(reason);
    onClose(); // Close dialog after saving
  };

  const handleCancel = () => {
    onClose();
  };

  const handleReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
    if (event.target.value.trim()) {
      setError("");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth={false}
      PaperComponent={PaperComponent}
      slotProps={{
        paper: {
          sx: {
            position: "absolute",
            top: `calc(50% - 300px)`,
            left: `calc(50% - 300px)`,
            transform: "translate(-50%, -50%)",
            width: "600px",
            display: "flex",
            flexDirection: "column",
          },
        },
      }}
    >
      <DialogTitle id='rejection-dialog-title' style={{ cursor: "move" }}>
        반려 처리
      </DialogTitle>
      <DialogContent sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, pb: 2 }}>
        <Typography variant='body2' sx={{ mb: 2 }}>
          반려 사유를 입력해주세요.
          <Box component='span' sx={{ color: "error.main", ml: 0.5 }}>
            *
          </Box>
        </Typography>
        <TextField
          autoFocus
          margin='dense'
          id='rejection-reason'
          label='반려 사유'
          type='text'
          fullWidth
          variant='outlined'
          multiline
          rows={9}
          maxRows={9}
          value={reason}
          onChange={handleReasonChange}
          error={!!error}
          required
          sx={{
            "& textarea": {
              overflow: "auto",
              resize: "none",
            },
          }}
        />
      </DialogContent>
      <DialogActions
        sx={{
          pb: 3,
          display: "flex",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Button onClick={handleCancel} variant='outlined'>
          취소
        </Button>
        <Button onClick={handleSave} variant='contained' color='primary'>
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectionDialog;
